import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import InteractionChat from "../InteractionChat/InteractionChat";

const determineTypeName = (fileExtension, valueDefault) => {
  switch (fileExtension.toLowerCase()) {
    case "jpeg":
    case "png":
    case "webp":
    case "jpe":
    case "gif":
    case "bmp":
    case "jpg":
      return "image";
    case "pdf":
    case "zip":
    case "xls":
    case "xml":
    case "xlsx":
    case "xlsm":
    case "txt":
    case "doc":
    case "docx":
    case "ppt":
    case "pptx":
    case "ppsx":
      return "document";
    case "wav":
    case "mp3":
    case "ogg":
    case "aac":
    case "m4a":
    case "amr":
    case "opus":
    case "mpeg":
      return "audio";
    case "m4v":
    case "mp4":
      return "video";
    default:
      return valueDefault ? valueDefault : "document";
  }
};

const getReplyProps = (message, arrayMessage, selectedChat, InfoUsers) => {
  if (
    message.replyid === "null" ||
    message.replyid === "undefined" ||
    message.replyid === "0" ||
    message.replyid === ""
  ) {
    return null;
  }

  const array = arrayMessage.filter((msg) => msg.messageid === message.replyid);

  if (array.length === 0) return null;

  const replyMessage = array[0];
  const textSeparator = replyMessage.message.split("~¿");
  const url = textSeparator[2].split(".")[1];
  const typenameMsg = determineTypeName(url, "mensagem");

  const text = textSeparator[0].replace(/¿/gi, "\n").replace(/§/gi, "\r\n");

  let nameReply = selectedChat.cliente;
  if (replyMessage.author === "Me" || replyMessage.typemon !== "0") {
    if (replyMessage.username) {
      nameReply =
        replyMessage.username === InfoUsers.username
          ? "Você"
          : replyMessage.username;
    } else {
      nameReply = "Você";
    }
  }

  return {
    id: message.replyid,
    username: nameReply,
    typename: typenameMsg,
    mimetype: replyMessage.typemsg,
    mensagem:
      replyMessage.typemsg === "4"
        ? "Localização"
        : replyMessage.typemsg === "11"
          ? "Contato"
          : text,
  };
};

const getDirection = (message, agent) => {
  if (message.username === agent) {
    return "right";
  } else if (message.author !== "Me") {
    return "left";
  } else if (message.author === "Gestor") {
    return "left";
  } else if (message.typemon !== "0" && message.typemon !== "1") {
    return "left";
  }
  return "right";
};

const getProps = (message, arrayMessage) => {
  let propsInfo = {
    textMsg: message.message,
    type: "",
    titlemsg: message.titlemsg,
    attachment: message.file,
    size: message.size,
    mimetypeId: message.mimetypeid,
    typeName: message.typename,
    buttons: message.buttons,
    botId: message.botid,
    buttonResponse: message.buttonResponse,
    location: message.location,
    contactInfo: "",
  };

  let separadorurlcaption = "";
  let url = "";

  switch (message.typemsg) {
    case "0":
      let mensagem_tratada = message.message.replace(/¿/gi, "\n");
      return { ...propsInfo, textMsg: mensagem_tratada };
    case "1":
      separadorurlcaption = message.message.split("~¿");
      let thumbnail = separadorurlcaption[0];
      let caption = separadorurlcaption[1];
      if (caption == "null") {
        caption = "";
      } else if (caption && caption !== "null") {
        caption = caption.replace(/¿/gi, "\r\n");
      }
      let size = separadorurlcaption[3];
      url = separadorurlcaption[2];
      if (url) {
        let separador = url.split(".");
        let get_name = separador[0].split("/");
        let verificarexistencia = "";

        if (separador[1] !== undefined && separador[1] !== "undefined") {
          let typenameMsg = determineTypeName(separador[1], "txt");

          let fileObject = {
            name: get_name[get_name.length - 1],
            size: size,
            type: typenameMsg,
            path_arquivos: url,
            extension: separador[1].toLowerCase(),
            id: message.messageid,
          };

          return {
            ...propsInfo,
            textMsg: caption,
            type: "attachment",
            attachment: fileObject,
            size: size,
            typeName: typenameMsg,
          };
        }
      }

      return { ...propsInfo, textMsg: caption, size: size, type: "attachment" };
    case "2":
      let get_json = message.message.replace(/§/gi, "\r\n");
      separadorurlcaption = get_json.split("~¿");
      let messageSeparada = separadorurlcaption[0]
        .replace(/¿¿/gi, "\r\n\r\n")
        .replace(/¿/gi, "\r\n");
      url = separadorurlcaption[1];
      let infos = message.options.split("§");
      let separador = infos[1].split("¿");
      let buttons = "";

      if (infos[1]) {
        buttons = JSON.parse(infos[1].replace(/(?<!\w)'|'(?!\w)/g, '"'));
      }

      let responseButton = "";
      const arrayFind = arrayMessage.find(
        (msg) => msg.replyid === message.messageid,
      );

      if (arrayFind) {
        responseButton = arrayFind.message;
      }

      let typeFile = "document";
      let fileObject = "";
      if (url && url !== "null" && url !== "undefined") {
        let separadorUrl = url.split(".");
        let get_name = separadorUrl[0].split("/");
        let verificarexistencia = "";
        if (separadorUrl[1]) {
          typeFile = determineTypeName(separadorUrl[1], "document");
        }

        fileObject = {
          name: get_name[get_name.length - 1],
          size: "",
          type: typeFile,
          path_arquivos: url,
          extension: separadorUrl[1] ? separadorUrl[1].toLowerCase() : "",
          id: message.messageid,
        };
      }

      return {
        ...propsInfo,
        textMsg: messageSeparada,
        attachment: fileObject,
        mimetypeId: infos[0],
        buttons: buttons,
        botId: infos[2],
        buttonResponse: responseButton,
      };

      break;
    case "4":
      let infosLocation = message.message.split("~¿");
      let location = {
        latitude: infosLocation[3],
        longitude: infosLocation[2],
        nomeEndereco: infosLocation[1],
        endereco: infosLocation[0],
      };

      return {
        ...propsInfo,
        textMsg: `${infosLocation[1]}\n${infosLocation[0]}`,
        location: location,
      };
    case "11":
      const cleanedJsonString = message.message.replace(
        /\\(?!["\\/bfnrtu])/g,
        "",
      );
      const contactInfo = JSON.parse(
        cleanedJsonString.replace(/(?<!\w)'|'(?!\w)/g, '"'),
      );

      return { ...propsInfo, textMsg: "", contactInfo: contactInfo };

    default:
      return propsInfo;
  }
};

const MessageList = ({
  arrayMessage,
  selectedChat,
  agent,
  searchText,
  handleAddContact,
  canSaveContact,
}) => {
  const InfoUsers = useSelector((state) => state.informationusers);

  let auxdia = "";

  return arrayMessage.map((message, i) => {
    const dia = message.dia !== auxdia ? message.dia : "";
    auxdia = message.dia;

    const direction = getDirection(message, agent);

    let nameUser = selectedChat.cliente;
    if (
      direction === "right" ||
      (message.typemon !== "0" && message.typemon !== "1")
    ) {
      let username = message.username.toLowerCase();
      if (message.username) {
        nameUser =
          InfoUsers.username === message.username
            ? "Você"
            : username.includes("saída")
              ? selectedChat.cliente
              : message.username;
      } else {
        nameUser = "Você";
      }
    }

    let monitoringMessage = false;
    if (direction !== "right" && nameUser !== selectedChat.cliente) {
      monitoringMessage = true;
    }

    let replyProps = getReplyProps(
      message.message,
      arrayMessage,
      selectedChat,
      InfoUsers,
    );
    let propsInfo = getProps(message, arrayMessage);

    return (
      <InteractionChat
        key={i}
        index={i}
        id={message.messageid}
        inputSearch={searchText}
        text={propsInfo.textMsg} //esse 0,1,2,4,11
        type={propsInfo.type} //esse 1
        date={{
          dia: dia,
          horaEnvio: message.datatime,
          statusmsg: message.statusmsg,
        }}
        titlemsg={propsInfo.titlemsg} //esse 11
        attachment={propsInfo.attachment} //esse 1,2
        size={propsInfo.size} //esse 1
        mimetypeId={propsInfo.mimetypeId} //esse 2
        mimetype={message.mimetype}
        typeName={propsInfo.typeName} //esse 1
        name={nameUser}
        direction={direction}
        buttons={propsInfo.buttons} //esse 2
        botId={propsInfo.botId} //esse 2
        reply={replyProps}
        buttonResponse={propsInfo.buttonResponse} //esse 2
        location={propsInfo.location} //esse 4
        allInfo={message}
        handleReply={() => {}}
        handleFavorite={() => {}}
        InfoUsers={InfoUsers}
        ContactId={selectedChat}
        contactInfo={propsInfo.contactInfo}
        contactLinkAdd={handleAddContact}
        exhibActions={false}
        canSaveContact={canSaveContact}
        monitoringMessage={monitoringMessage}
      />
    );
  });
};

export default MessageList;
